export default __webpack_public_path__ + "static/laminas_2-cdf0ffb7387f8d24baebecfa52056947.png";